import { render, staticRenderFns } from "./DistTimeDiffBlock.vue?vue&type=template&id=4fea7e50&scoped=true&"
import script from "./DistTimeDiffBlock.vue?vue&type=script&lang=js&"
export * from "./DistTimeDiffBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea7e50",
  null
  
)

export default component.exports